<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2 mr-2">{{getCurrentLocaleData}}</span>
    </span>
    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item @click="updateLocale('tr')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/tr.png" alt="tr" /> &nbsp;Türkiye
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('en')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;English
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('ar')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/sa.png" alt="sa" /> &nbsp;المملكة العربية السعودية
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('it')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/it.png" alt="it" /> &nbsp;Italia
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('ru')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/ru.png" alt="ru" /> &nbsp;Россия
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('fr')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;France
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('de')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;Deutsche
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('pt')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;Portugal
      </vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('nl')">
        <img class="h-4 w-5 mr-1" src="@/assets/images/flags/nl.png" alt="nl" /> &nbsp;Nederland
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
/* eslint-disable */
import Vee from "../../../../shared/vee-validate";

export default {
  computed: {
    i18n_locale_img() {
      // Use below code to dynamically fetch image instead of if-else
      // NOTE: We used if-else because laravel throws error in 'yarn prod'.
      // If you are not using laravel + Vue, you can use below code to dynamically get image
      // return require(`@/assets/images/flags/${this.$i18n.locale}.png`)

      const locale = this.$i18n.locale;
      if (locale === "tr") return require("@/assets/images/flags/tr.png");
      else if (locale === "en") return require("@/assets/images/flags/en.png");
      else if (locale === "ar") return require("@/assets/images/flags/sa.png");
      else if (locale === "pt") return require("@/assets/images/flags/pt.png");
      else if (locale === "fr") return require("@/assets/images/flags/fr.png");
      else if (locale === "de") return require("@/assets/images/flags/de.png");
      else if (locale === "ru") return require("@/assets/images/flags/ru.png");
      else if (locale === "it") return require("@/assets/images/flags/it.png");
      else if (locale === "nl") return require("@/assets/images/flags/nl.png");
      else return require("@/assets/images/flags/en.png");
    },
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale === "tr") return "Türkiye";
      else if (locale === "en") return "English";
      else if (locale === "ar") return "المملكة العربية السعودية";
      else if (locale === "pt") return "Portugal";
      else if (locale === "fr") return "France";
      else if (locale === "de") return "Deutsche";
      else if (locale === "ru") return "Россия";
      else if (locale === "it") return "Italia";
      else if (locale === "nl") return "Nederland";
    }
  },
  methods: {
    async updateLocale(locale) {
      var vee_lang = Vee.tr;
      this.$i18n.locale = locale;
      if (locale === "tr") {
        await localStorage.setItem("lang", locale + "-TR");
        vee_lang = Vee.tr;
        await Vee.VeeValidate.Validator.localize({ lang: vee_lang });
        this.$store.state.language = locale + "-TR";
        window.location.href = this.$route.path;
      } else if (locale === "en") {
        await localStorage.setItem("lang", locale + "-US");
        vee_lang = Vee.en;
        await Vee.VeeValidate.Validator.localize({ lang: vee_lang });
        window.location.href = this.$route.path;
      } else if (locale === "ar") {
        await localStorage.setItem("lang", locale + "-SA");
        vee_lang = Vee.sa;
        await Vee.VeeValidate.Validator.localize({ lang: vee_lang });
        this.$store.state.language = locale + "-SA";
        window.location.href = this.$route.path;
      } else if (locale === "pt") {
        await localStorage.setItem("lang", locale + "-PT");
        vee_lang = Vee.pt;
        await Vee.VeeValidate.Validator.localize({ lang: vee_lang });
        this.$store.state.language = locale + "-PT";
        window.location.href = this.$route.path;
      } else if (locale === "fr") {
        await localStorage.setItem("lang", locale + "-FR");
        vee_lang = Vee.fr;
        await Vee.VeeValidate.Validator.localize({ lang: vee_lang });
        this.$store.state.language = locale + "-FR";
        window.location.href = this.$route.path;
      } else if (locale === "de") {
        await localStorage.setItem("lang", locale + "-DE");
        vee_lang = Vee.de;
        await Vee.VeeValidate.Validator.localize({ lang: vee_lang });
        this.$store.state.language = locale + "-DE";
        window.location.href = this.$route.path;
      } else if (locale === "ru") {
        await localStorage.setItem("lang", locale + "-RU");
        vee_lang = Vee.ru;
        await Vee.VeeValidate.Validator.localize({ lang: vee_lang });
        this.$store.state.language = locale + "-RU";
        window.location.href = this.$route.path;
      } else if (locale === "it") {
        await localStorage.setItem("lang", locale + "-IT");
        vee_lang = Vee.it;
        await Vee.VeeValidate.Validator.localize({ lang: vee_lang });
        this.$store.state.language = locale + "-IT";
        window.location.href = this.$route.path;
      } else if (locale === "nl") {
        await localStorage.setItem("lang", locale + "-NL");
        vee_lang = Vee.it;
        await Vee.VeeValidate.Validator.localize({ lang: vee_lang });
        this.$store.state.language = locale + "-NL";
        window.location.href = this.$route.path;
      }
    }
  }
};
</script>
